import { CopyButton } from '@/components/copy-button';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { ComponentProps, ReactNode } from 'react';

type ButtonPropsWithTestId = ComponentProps<typeof Button> & { 'data-testid'?: string };

export const StartOrJoinSession = ({
  label,
  url,
  whenUrlEmptyRender,
  canCopyUrl,
  startButtonProps = {},
}: {
  label: string;
  url?: string | null;
  whenUrlEmptyRender?: ReactNode;
  startButtonProps?: ButtonPropsWithTestId;
  canCopyUrl?: boolean;
}) => {
  if (!whenUrlEmptyRender) {
    whenUrlEmptyRender = <Button disabled>{label}</Button>;
  }

  return url ? (
    <div className="flex gap-2">
      <a href={url} target="_blank" rel="noreferrer noopener" data-testid={startButtonProps['data-testid']}>
        <Button icon={ExternalLink} {...startButtonProps} type="button">
          {label}
        </Button>
      </a>
      {canCopyUrl && <CopyButton content={url} />}
    </div>
  ) : (
    whenUrlEmptyRender
  );
};
